// extracted by mini-css-extract-plugin
export default {"mail_btn":"notices-table_mail_btn__EeEZH"};